import { useUpdateEffect } from 'react-use';

import { useBoolean } from '@dreryk/react-common';

import { useRefetchMedicalServices } from '../shared/queries/useRefetchMedicalServices';

import { MedicalServiceCreateModal } from './MedicalServiceCreateModal';

type MedicalServiceCreateModalOpenerRenderer = (renderProps: { openModal: VoidFunction }) => JSX.Element;

type MedicalServiceCreateModalOpenerProps = {
   readonly children: MedicalServiceCreateModalOpenerRenderer;
};

export const MedicalServiceCreateModalOpener = (props: MedicalServiceCreateModalOpenerProps): JSX.Element => {
   const refetchMedicalServices = useRefetchMedicalServices();
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   useUpdateEffect(() => {
      if (!modalOpened) {
         refetchMedicalServices();
      }
   }, [modalOpened]);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}
         {modalOpened ? <MedicalServiceCreateModal onSuccess={closeModal} closeModal={closeModal} /> : null}
      </>
   );
};
